import { Tooltip, Typography } from "antd"

const { Text } = Typography

export function getColumns() {
  return [
    {
      title: "Клиент",
      dataIndex: "fullName",
      key: "fullName",
      sorter: (a, b) => String(a.fullName).localeCompare(String(b.fullName), "ru"),
    },
    {
      title: "Телефон",
      key: "phone",
      render: (_, record) => record.user?.phone ?? "—",
    },
    {
      title: "Email",
      key: "email",
      render: (_, record) => record.user?.email ?? "—",
    },
    {
      title: "external_guid",
      key: "externalGuid",
      render: (_, record) =>
        record.user?.externalGuid ? (
          <Tooltip title={record.user.externalGuid} mouseLeaveDelay={0}>
            <Text copyable={{ text: record.user.externalGuid }}>
              {String(record.user.externalGuid).slice(0, 8)}…
            </Text>
          </Tooltip>
        ) : (
          "—"
        ),
    },
    {
      title: "Товар добавлен",
      dataIndex: "lastAddedAt",
      key: "lastAddedAt",
      sorter: (a, b) => compareDates(a.lastAddedAt, b.lastAddedAt),
      defaultSortOrder: "descend",
    },
    {
      title: "В корзине",
      key: "cart",
      render: (_, record) => `${record.totalCount} шт · ${record.totalPrice} ₽`,
    },
    {
      title: "Заказов в МП",
      dataIndex: "ordersMpCount",
      key: "ordersMpCount",
      sorter: (a, b) => a.ordersMpCount - b.ordersMpCount,
    },
    {
      title: "Заказов на кассе",
      dataIndex: "ordersCashCount",
      key: "ordersCashCount",
      sorter: (a, b) => a.ordersCashCount - b.ordersCashCount,
    },
    {
      title: "Последний заказ",
      key: "lastOrderAt",
      sorter: (a, b) => compareDates(a.lastOrderAt, b.lastOrderAt),
      render: (_, record) =>
        record.lastOrderAt ? (
          <Tooltip
            mouseLeaveDelay={0}
            title={`МП: ${record.lastMpOrderAt ?? "—"} · Касса: ${
              record.lastCashOrderAt ?? "—"
            }`}
          >
            {record.lastOrderAt}
          </Tooltip>
        ) : (
          "—"
        ),
    },
  ]
}

/** Даты приходят строкой dd.mm.yyyy hh:mm — сортируем по реальному времени. */
function compareDates(first, second) {
  return toTimestamp(first) - toTimestamp(second)
}

function toTimestamp(value) {
  if (!value) return 0

  const [date, time = "00:00"] = String(value).split(" ")
  const [day, month, year] = date.split(".")

  return new Date(`${year}-${month}-${day}T${time}`).getTime() || 0
}
